// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2zo0O","colMin":"styles_colMin__3zYhr","colCheckbox":"styles_colCheckbox__3Rwrh"};